const { BaseClient } = require('../shared')

class ClaimAccumulatorClient extends BaseClient {
    constructor(claimAccumulatorServiceUrl = process.env.CLAIM_ACCUMULATOR_API, axiosOptions) {
        super(claimAccumulatorServiceUrl, undefined, axiosOptions)
    }

    /**
     * @param {string} accumulatorId 
     */
    async getAccumulator(accumulatorId) {
        this.createAxiosInstance()

        const response = await this.axiosInstance.get(`query/accumulator/${accumulatorId}`)

        if (response.status !== 200) {
            return null
        }

        return response.data
    }
}

module.exports = {
    ClaimAccumulatorClient
}